import React from 'react';
import './FormGroup.css';
import SingleLineField from'../SingleLineField/SingleLineField';

const FormGroup = (props) => {

    let fields = [];
    let first;

    if (typeof props.config.Fields[Symbol.iterator] === 'function') {
        for(let item of props.config.Fields){
            fields.push(item);
        }
    }

    return (
        <React.Fragment>
            {fields.map((config) => {
                if (first === undefined) {
                    first = config.Type === "text" ? undefined : true;
                } else {
                    first = false;
                }
                return (
                 <SingleLineField
                    key={config.Id}
                    config={config}
                    changeHandler={props.changeHandler}
                    onKeyDown={props.onKeyDown}
                    focusOut={props.fieldFocusOut}
                    first={first}
                    language={props.language}
                    id={props.id}
                ></SingleLineField>
             )}
             )}
        </React.Fragment>
    )
};
  
export default FormGroup;